var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-flatpickr-wrapper',_vm._g(_vm._b({attrs:{"config":_vm.config,"hide-date":_vm.hideDate,"hide-time":_vm.hideTime,"inline":_vm.inline,"no-buttons":_vm.noButtons,"state":_vm.input_state,"value":_vm.value}},'o-flatpickr-wrapper',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }